import React from "react";
import Dashboard from "../components/Dashboard/dashboard";

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;
